import { useEffect, useRef } from 'react'

/**
 * Custom hook to use setInterval
 *
 * @example
 * useInterval(() => setCount((prev) => prev + 1), 4000)
 *
 * @param callback a function to be called
 * @param delay time in milliseconds
 */
export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef<() => void>(undefined)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current()
      }
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => {
        clearInterval(id)
      }
    }
  }, [delay])
}
